module.exports = __webpack_public_path__ + "efb554d601b01bdeb307016ac2e76118.pdf";